module.exports = __webpack_public_path__ + "static/media/03 Generali Zycie i zdrowie Ustandaryzowany dokument.98ef3c3a.pdf";